import SmartShopper from './images/smartShopper.JPG';
import OrderUp from './images/orderUp.png';
import Mothra from './images/mothra.png';
import GoogleBooks from './images/googleBooks.jpg';
import ReactEmployee from './images/reactEmployee.png';
import Burgers from './images/burgers.png';


const data = [
  {
    "key" : "1",
    "name": "Smart Shopper",
    "description": "A “smart” shopping list progressive web app (PWA) that learns your buying habits and helps you remember what you’re likely to need to buy on your next trip to the store. Built with React and Firebase with a team of 3 other developers and 3 mentors over the course of 8 weeks.",
    "imgUrl": SmartShopper,
    "link": "https://tcl-17-smart-shopping-list.netlify.app/",
    "github": "https://github.com/the-collab-lab/tcl-17-smart-shopping-list"
  },
  {
    "key" : "2",
    "name": "Order Up",
    "description": "A progressive web application for digital point of ordering, and front- and back-of-house management. Built with JavaScript, Node, Express, React, and MongoDB  with a team of 4 other developers over the course of 2 weeks.",
    "imgUrl": OrderUp,
    "link": "https://order-up-fork.herokuapp.com/",
    "github": "https://github.com/rachelrohrbach/order-up"
  },
  {
    "key" : "3",
    "name": "Mothra",
    "description": "A project planning app inspired by JIRA that allow users to create, update and delete tasks and projects. Built with a team of 3 other developers over the course of 2 weeks using JavaScript, Node, Express, Handlebars, and mySQL. Focused on the front-end logic and writing tests.",
    "imgUrl": Mothra,
    "link": "https://the-best-project-manager.herokuapp.com/",
    "github": "https://github.com/maximilianc88/Project-Planner-Application"
  },
  {
    "key" : "4",
    "name": "(React) Google Books Search",
    "description": "React-based Google Books Search app using the Google Books API. The user can navigate to the book on the Google Play Store and create a saved books list.",
    "imgUrl": GoogleBooks,
    "link": "https://fast-tundra-68220.herokuapp.com/",
    "github": "https://github.com/rachelrohrbach/google-books-search"
  },
  {
    "key" : "5",
    "name": "React Employee Directory",
    "description": "An employee directory created with React. It allows the user to view, sort, and search for employee information including an image, first and last name, phone number, email and date of birth in a table format.",
    "imgUrl": ReactEmployee,
    "link": "https://rachelrohrbach.github.io/react-employee-directory/",
    "github": "https://github.com/rachelrohrbach/react-employee-directory"
  },
  {
    "key" : "1",
    "name": "Devour the Burgers",
    "description": "Devour the Burgers is an interactive application built with a custom ORM utilizing the MVC design pattern. Users can create, devour and re-make burgers.",
    "imgUrl": Burgers,
    "link": "https://evening-bayou-25102.herokuapp.com/",
    "github": "https://github.com/rachelrohrbach/burger"
  }
];

export default data;